/*global Materialize*/
/*eslint no-undef: ["error", { "typeof": true }] */

import React, { Component } 	from 'react';
import { connect } 				from 'react-redux';
import { fetch } 					from '@fyresite/fetch';
import Button                     from '../../../components/Button';
import { permissionsByNumber } from '../../../constants.js';
import Pagination               from '../../../components/Pagination'
import ModalConfirm from '../../../components/Modal/ModalConfirm'
import Modal from '../../../components/Modal'

const PERPAGE = 10;

class ListUsers extends Component {
    constructor(props, context){
        super(props, context);

        this.state = {
            users:   		[],
            currentPage:    1,
            pages: 			0,
            search: 		'',
            totalUsers:     0,
            showAll:	    false,


            showModal: false,
            modalChildren: '',
			modalConfig: {}
        }
    }

    componentWillMount() {
        if(this.props.user.permissions < 5){
        this.props.history.push('/dashboard');
        } else {
        this.searchUsers('', this.state.currentPage);
        }
    }

  searchUsers() {
    // let status;
    fetch(`/api/v1/user/get/${this.state.currentPage}?perPage=${PERPAGE}`, {
        method: 'GET',
        headers: { "Content-Type": "application/json" }
    }).then(res => {
        // status = res.status;
        return res.json();
    }).then(json => {
        if(json.code === 200){
            this.setState({
                users: json.result.users,
                pages: Math.ceil(json.result.count / PERPAGE),
                totalUsers: json.result.count
            });
        } else {
            Materialize.toast(`Error occurred, ${json.message}`, 4000, 'red');
        }
    }).catch(err => {
        Materialize.toast(`Fetch error ${err}`, 4000, 'red');
    })
  }


  handleShowModal(showModal = false, children, modalConfig = {}) {
    let modalChildren = typeof children !== 'undefined' ? children : '';

    this.setState({
        showModal,
        modalConfig,
        modalChildren
    });
  }

    removeUser(user, e){

        this.handleShowModal(true,
            <ModalConfirm
                header={"Confirm"}
                message={`Are you sure you want to delete the user, ${user.email}?`}
                button={ {onClick: e => {
                
                    fetch(`/api/v1/user/delete/${user.id}`, {
                        method: 'POST',
                        headers: { "Content-Type": "application/json" }
                    }).then(res => {
                        // status = res.status;
                        return res.json();
                    }).then(json => {
                        if(json.code === 200){
                            let users = JSON.parse(JSON.stringify(this.state.users));
                            for(var x = 0; x < users.length; x ++ ){
                                let loopeduser = users[x];
                                if(loopeduser.id === user.id){
                                    users.splice(x, 1);
                                    this.setState({
                                        users
                                    }, () => {
                                        this.handleShowModal(false);
                                    })
                                    break;
                                }
                            }
                            Materialize.toast("User was removed", 4000, 'green');
                        } else {
                            Materialize.toast(`Error occurred, ${json.message}`, 4000, 'red');
                        }
                    }).catch(err => {
                        Materialize.toast(`Fetch error ${err}`, 4000, 'red');
                    })

                }, text: "Yes"} }
                cancel={ {text: "No"} } />);
    }

    handlePageChange(currentPage) {
        /** Once state is set we can update the members */
        this.setState({
            currentPage
        }, () => {
            this.searchUsers();
        })
    }

    /**
   * renderEmployeeList - Builds the JSX for rendering the employee list
   * since it requires a little more complex if/else handling than the
   * render() function allows
   *
   * @return {Array}  Array of JSX representing the employee list
   */
  renderUserList() {
    let html = [];

    this.state.users.forEach((user, index) => {

      let classes = [];
      if (user.status === 'deleted') {
        classes.push('inactive');
      }

      html.push(
        <tr className={classes.join(' ')} key={user.id}>
            <td>
                <a onClick={e => this.props.history.push(`/dashboard/edit-user/${user.id}`)}>
                    {`${user.firstName} ${user.lastName.split('')[0] || ""}.`}
                </a>
            </td>
          <td> {`${permissionsByNumber[user.permissions]}`} </td>
          <td className="remove"> <i onClick={this.removeUser.bind(this, user)} className="material-icons">clear</i> </td>
        </tr>
      );
    });
    return html;
  }

    render() {
        return (
            <div className="list-users">
                <div className="list-users-inner">
                    <div className="buttons">
                        <Button onClick={e => {this.props.history.push("/dashboard/add-user")}}> Add User </Button>
                    </div>
                    <table className="table striped bordered">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Permissions</th>
                                <th className="remove">Remove</th>
                            </tr>
                        </thead>
                        <tbody>
                            { this.renderUserList() }
                        </tbody>
                    </table>
                    {
                        this.state.pages > 1 ?
                        <Pagination
                            total={this.state.totalUsers}
                            current={this.state.currentPage}
                            onChange={this.handlePageChange.bind(this)}
                            perPage={PERPAGE} />
                        : ''
                    }
                </div>
                {
                    this.state.showModal ?
                    <Modal config={this.state.modalConfig}>
                        {this.state.modalChildren}
                    </Modal>
                    : ''
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
  return {
    user: state.user
  }
}

export default connect(mapStateToProps)(ListUsers);



// WEBPACK FOOTER //
// ./src/pages/Dashboard/ListUsers/ListUsers.js